import React, { createContext, useState } from 'react'

import type { LatLngExpression } from 'leaflet'

export type SelectedOffer = {
	coordinates: LatLngExpression
	id: string
}

// eslint-disable-next-line react-refresh/only-export-components
export const MapSelectedContext = createContext<
	[
		SelectedOffer | null,
		React.Dispatch<React.SetStateAction<SelectedOffer | null>>
	]
	// eslint-disable-next-line
>([null, () => {}])

export interface MapSelectedProviderProps {
	children: React.ReactNode
}

export const MapSelectedProvider = ({ children }: MapSelectedProviderProps) => {
	const [selected, setSelected] = useState<SelectedOffer | null>(null)

	return (
		<MapSelectedContext value={[selected, setSelected]}>
			{children}
		</MapSelectedContext>
	)
}
